<script lang="ts" setup>import { ref as _ref } from 'vue';

import Trix from '@vendor/trix/trix.esm.min.js'
import '@vendor/trix/trix.css'

withDefaults(defineProps<{
  placeholder?: string
}>(), {  })

let trixContent = (defineModel<string>({ required: true }))

const trixEl = _ref<{ value: string; editor: { loadHTML: ((string: any) => void) } }>()!

const hiddenId = useId()

function trixChange () {
  // Trix wraps the content in a <div /> tag that we do not want
  trixContent.value = stripDivWrapper(trixEl.value.value)
}

function stripDivWrapper (content: string) {
  if (content.startsWith('<div>') && content.endsWith('</div>')) {
    return content.slice(5, -6)
  }
  return content
}

// When the AI Button generates new text, replace the editor value
watch(() => trixContent.value, () => {
  // Only update the editor value if it is different (such as from the AI button)
  // Otherwise the cursor jumps to the beginning
  if (trixEl.value && trixContent.value !== stripDivWrapper(trixEl.value.value)) {
    trixEl.value.editor?.loadHTML(trixContent.value)
  }
})

document.addEventListener('trix-before-initialize', () => {
  // NOTE: The Linking functionality has been commented out for the time being.
  Trix.config.toolbar.getDefaultHTML = () => {
    return `
        <div class="trix-button-row">
            <span class="trix-button-group trix-button-group--text-tools" data-trix-button-group="text-tools">
                <button type="button" class="trix-button trix-button--icon trix-button--icon-bold"
                    data-trix-attribute="bold" data-trix-key="b" title="Bold" tabindex="-1">Bold</button>
                <button type="button" class="trix-button trix-button--icon trix-button--icon-italic"
                    data-trix-attribute="italic" data-trix-key="i" title="Italic" tabindex="-1">Italic</button>
                <button type="button" class="trix-button trix-button--icon trix-button--icon-link"
                    data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="Link"
                    tabindex="-1">Link</button>
                <button type="button" class="trix-button trix-button--icon trix-button--icon-bullet-list"
                    data-trix-attribute="bullet" tabindex="-1">List</button>
            </span>
    </div>

    <div class="trix-dialogs" data-trix-dialogs>
      <div class="trix-dialog trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">
        <div class="trix-dialog__link-fields">
          <input type="url" name="href" class="trix-input trix-input--dialog" placeholder="" aria-label="url" r
            equired data-trix-input>
          <div class="trix-button-group">
            <input type="button" class="trix-button trix-button--dialog" value="Link"
                data-trix-method="setAttribute">
            <input type="button" class="trix-button trix-button--dialog" value="Unlink"
                data-trix-method="removeAttribute">
          </div>
        </div>
      </div>
    </div>`
  }
})

</script>

<template>
  <div class="trix">
    <input :id="hiddenId" :value="trixContent" type="hidden" name="content">
    <trix-editor
      ref="trixEl"
      class="g-input g-input-text"
      autofocus
      :input="hiddenId"
      :placeholder="placeholder"
      @trix-change="trixChange"
    />
  </div>
</template>

<style lang="scss">
.trix trix-toolbar {
  .trix-button-group {
    @apply rounded-v2sm border-grey-primary;
  }

  .trix-button--icon {
    @apply border-grey-primary;

    border-bottom: none;
  }
}

.trix trix-editor ul {
  list-style: inside;
}
</style>
